export function LegalFooterLinks() {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[#707983]">
      <div>© {new Date().getFullYear()} RESONANCE. All rights reserved.</div>
      <div className="flex items-center gap-6">
        <a href="/reviews" className="hover:text-[#A9B0B8] transition-colors">Reviews</a>
        <a href="/faq" className="hover:text-[#A9B0B8] transition-colors">FAQ</a>
        <a href="/verify" className="hover:text-[#A9B0B8] transition-colors">Verification</a>
        <a href="/privacy" className="hover:text-[#A9B0B8] transition-colors">Privacy</a>
        <a href="/terms" className="hover:text-[#A9B0B8] transition-colors">Terms</a>
        <a href="/ai-disclosure" className="hover:text-[#A9B0B8] transition-colors">AI Disclosure</a>
      </div>
    </div>
  );
}
